module.exports = __webpack_public_path__ + "images/Square-9440ca.png";